'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-334/node_modules/@eliadmin/core/src/pages/(jobportal)/edit-offer/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-334/node_modules/@eliadmin/core/src/pages/(jobportal)/edit-offer/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/56930e48a53b"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

